import { NumericPipe, NUMERIC_TYPES } from './numeric.pipe';
import { AllCapsPipe } from './all-caps.pipe';
import { SortPipe } from './sortby.pipe';
import { TimeUntilPipe } from './time-until.pipe';

const PIPES = [NumericPipe, AllCapsPipe, TimeUntilPipe, SortPipe];

export {
  NumericPipe,
  AllCapsPipe,
  TimeUntilPipe,
  SortPipe,
  NUMERIC_TYPES,
  PIPES
};



// WEBPACK FOOTER //
// ./src/app/shared/pipes/index.ts